import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import * as QueryString from 'query-string';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Loading } from '@rd-web-markets/shared/dist/util';
import searchV2Service from '@services/company_claim_group_search.service';
import SectionHeader from './SectionHeader';
import CompaniesResults from './CompaniesResults';
import ClaimGroupsResults from './ClaimGroupsResults';

const CompanyClaimGroupSearchPage = ({ accountType }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const params = QueryString.parse(location.search);
  const query = params.query || '';

  const [loading, setLoading] = useState(false);
  const [results] = searchV2Service.useSearch(setLoading, query);

  return (
    <div className="px-4 py-4" style={{ maxWidth: '1400px', margin: '0 auto' }}>
      <h4 className="mb-4 text-secondary fw-normal">Search results</h4>

      {loading && <Loading />}

      {!loading && (
        <>
          <Card className="mb-4 px-4 py-3">
            <SectionHeader icon="description" title={t('companies') || 'Companies'} count={results.companies && results.companies.length} />
            <CompaniesResults companies={results.companies || []} accountType={accountType} />
          </Card>
          <Card className="px-4 py-3">
            <SectionHeader icon="folder" title={t('claims') || 'Claims'} count={results.claim_groups && results.claim_groups.length} />
            <ClaimGroupsResults claimGroups={results.claim_groups || []} accountType={accountType} />
          </Card>
        </>
      )}
    </div>
  );
};

export default CompanyClaimGroupSearchPage;
